'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'fill-drip';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f576';
var svgPathData = ['M48.4 304l422.2 0-170.3 170.3C286.4 488.2 267.6 496 248 496s-38.4-7.8-52.3-21.7L69.7 348.3c-12-12-19.4-27.6-21.2-44.3zM464 480c0-3.4 1.2-9.4 4.4-18 3-8.3 7.4-17.7 12.5-27.6 9.9-19.2 22-39.1 31.2-53.4 9.1 14.3 21.3 34.1 31.2 53.4 5.1 9.9 9.4 19.3 12.5 27.6 3.2 8.6 4.4 14.6 4.4 18 0 26.5-21.5 48-48 48s-48-21.5-48-48z', 'M275.7 37.7l-81.4 81.4 91.3 91.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L183 130.3 69.7 243.7c-12 12-19.4 27.6-21.2 44.3l438.2 0 19.7-19.7C520.2 254.4 528 235.6 528 216s-7.8-38.4-21.7-52.3L380.3 37.7C366.4 23.8 347.6 16 328 16s-38.4 7.8-52.3 21.7zM58.3 232.4L171.7 119 98.3 45.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l73.4 73.4 81.4-81.4C281.3 9.5 304.1 0 328 0s46.7 9.5 63.6 26.3L517.7 152.4C534.5 169.3 544 192.1 544 216s-9.5 46.7-26.3 63.6L311.6 485.7C294.7 502.5 271.9 512 248 512s-46.7-9.5-63.6-26.3L58.3 359.6C41.5 342.7 32 319.9 32 296s9.5-46.7 26.3-63.6zM48.4 304c1.8 16.7 9.3 32.3 21.2 44.3L195.7 474.3C209.6 488.2 228.4 496 248 496s38.4-7.8 52.3-21.7L470.6 304 48.4 304zM560 480c0-3.4-1.2-9.4-4.4-18-3-8.3-7.4-17.7-12.5-27.6-9.9-19.2-22-39.1-31.2-53.4-9.1 14.3-21.3 34.1-31.2 53.4-5.1 9.9-9.4 19.3-12.5 27.6-3.2 8.6-4.4 14.6-4.4 18 0 26.5 21.5 48 48 48s48-21.5 48-48zm16 0c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7 6-9.4 19.5-9.4 25.5 0 18.7 29.1 51.2 83.5 51.2 108.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFillDrip = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;